import React from 'react'
import styles from './Navbar.module.css'
import logo from '../../assets/logo2.png'

const Navbar = () => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.inner}>
        <a href="#">
          <img src={logo} alt="Logo" className={styles.logo} />
        </a>
        <a href="tel:+918830586114" className={styles.cta}>+918830586114</a>
      </div>
    </nav>
  )
}

export default Navbar